(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var strips = document.querySelectorAll('[data-naylumi-trust-strip]');
    if (!strips.length) return;

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) return;

    strips.forEach(function (strip) {
      strip.classList.add('nts-anim-ready');

      if (!('IntersectionObserver' in window)) {
        strip.classList.add('nts-visible');
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            strip.classList.add('nts-visible');
            io.disconnect();
          }
        });
      }, { threshold: 0.25 });

      io.observe(strip);
    });
  });
})();
